var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.5C1.45 18.5 0.979002 18.304 0.587002 17.912C0.195002 17.52 -0.000664969 17.0493 1.69779e-06 16.5V2.5C1.69779e-06 1.95 0.196002 1.479 0.588002 1.087C0.980002 0.695002 1.45067 0.499335 2 0.500002H13.175C13.4417 0.500002 13.696 0.550002 13.938 0.650002C14.18 0.750002 14.3923 0.891668 14.575 1.075L17.425 3.925C17.6083 4.10834 17.75 4.321 17.85 4.563C17.95 4.805 18 5.059 18 5.325V16.5C18 17.05 17.804 17.521 17.412 17.913C17.02 18.305 16.5493 18.5007 16 18.5H2ZM16 5.35L13.15 2.5H2V16.5H16V5.35ZM9 15.5C9.83333 15.5 10.5417 15.2083 11.125 14.625C11.7083 14.0417 12 13.3333 12 12.5C12 11.6667 11.7083 10.9583 11.125 10.375C10.5417 9.79167 9.83333 9.5 9 9.5C8.16667 9.5 7.45834 9.79167 6.875 10.375C6.29167 10.9583 6 11.6667 6 12.5C6 13.3333 6.29167 14.0417 6.875 14.625C7.45834 15.2083 8.16667 15.5 9 15.5ZM4 7.5H11C11.2833 7.5 11.521 7.404 11.713 7.212C11.905 7.02 12.0007 6.78267 12 6.5V4.5C12 4.21667 11.904 3.979 11.712 3.787C11.52 3.595 11.2827 3.49934 11 3.5H4C3.71667 3.5 3.479 3.596 3.287 3.788C3.095 3.98 2.99934 4.21734 3 4.5V6.5C3 6.78334 3.096 7.021 3.288 7.213C3.48 7.405 3.71734 7.50067 4 7.5ZM2 5.35V16.5V2.5V5.35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.1c5d53be4a34ff4611a72246cd922e40.svg";
export { ForwardRef as ReactComponent };